module.exports = __webpack_public_path__ + "img/FaqAlmode (3).cbfe4727.png";